import { useQuery } from 'react-query'
import CO2Service from '~/api/services/co2'
import { FarmersService } from '~/api/services/farmers'
import { onError } from '~/utils/helpers'

const getCO2FootprintsOptions = (data?) => useQuery(
  'co2-footprints-options',
  () => CO2Service.getCO2FootprintsOptions(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCO2Footprints = (data?) => useQuery(
  'co2-footprints-data',
  () => CO2Service.getCO2Footprints(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCO2Count = (data?) => useQuery(
  'co2-footprints-count',
  () => CO2Service.getCO2Count(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmerGroups = (id, data?) => useQuery(
  'co2-farmer-groups',
  () => CO2Service.getCO2FarmerGroups(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getFarmers = (id, data?) => useQuery(
  'co2-farmers',
  () => CO2Service.getCO2Farmers(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCo2List = (enabled) => useQuery(
  'co2-list',
  () => enabled && CO2Service.getCO2List(),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getEnergyData = (id: string, data: any) => useQuery(
  'co2-energy-data',
  () => CO2Service.getEnergyData(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCo2Farmers = (id: string, data: any) => useQuery(
  'co2-farmers',
  () => CO2Service.co2Farmers(id, data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data.data
    }
  }
)

const getCo2FarmersList = (data: any) => useQuery(
  'co2-farmers-list-data',
  () => data && FarmersService.getFarmers(data),
  {
    onError,
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    retry: 1,
    select: (data) => {
      return data?.data
    }
  }
)

const CO2ClimateQuery = {
  getCO2FootprintsOptions,
  getCO2Footprints,
  getCO2Count,
  getFarmerGroups,
  getFarmers,
  getCo2List,
  getEnergyData,
  getCo2Farmers,
  getCo2FarmersList
}

export default CO2ClimateQuery